import { Note, StaffDataRedux, StaffState } from '@/types/Staff';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: StaffState = {
  staffData: {
    totalPages: 0,
    page: 1,
    data: null,
    searchText: '',
    filterValue: null,
    sortKey: 'id',
    sortDirection: 'desc',
  },
  staffNotesData: {
    data: null,
    editingNoteId: null,
  },
  refreshKey: 0,
};

const staffSlice = createSlice({
  name: 'staff',
  initialState,
  reducers: {
    setStaffData(state, action: PayloadAction<StaffDataRedux>) {
      state.staffData = action.payload;
    },
    setStaffEditAction(state, action: PayloadAction<number | boolean | null>) {
      state.staffNotesData.editingNoteId = action.payload;
    },
    setStaffPageAction(state, action: PayloadAction<number>) {
      state.staffData.page = action.payload;
    },
    setStaffSearchTextAction(state, action: PayloadAction<string>) {
      state.staffData.searchText = action.payload;
      state.staffData.page = 1;
    },
    setArchiveStaffAction(state, action: PayloadAction<number>) {
      state.staffData.data = state.staffData.data?.filter(staff => staff.id !== action.payload) ?? null;
    },
    setStaffFilterValue(state, action: PayloadAction<any>) {
      state.staffData.filterValue = action.payload;
    },
    setStaffSortAction: (state, action: PayloadAction<{ sortKey: string; sortDirection: 'asc' | 'desc' }>) => {
      state.staffData.sortKey = action.payload.sortKey;
      state.staffData.sortDirection = action.payload.sortDirection;
    },
    setStaffNotesAction(state, action: PayloadAction<Note[] | null>) {
      state.staffNotesData.data = action.payload;
    },
    createStaffNoteAction(state, action: PayloadAction<Note>) {
      if (state.staffNotesData.data) {
        state.staffNotesData.data.push(action.payload);
      }
    },
    updateStaffNoteAction(state, action: PayloadAction<Note>) {
      if (state.staffNotesData.data) {
        const index = state.staffNotesData.data.findIndex(note => note.id === action.payload.id);
        if (index !== -1) {
          state.staffNotesData.data[index] = action.payload;
        }
      }
    },
    incrementRefreshKey: state => {
      state.refreshKey += 1;
    },
    clearStaffStateAction: () => initialState,
  },
});

export const {
  setStaffData,
  setArchiveStaffAction,
  setStaffPageAction,
  setStaffSearchTextAction,
  clearStaffStateAction,
  setStaffEditAction,
  setStaffFilterValue,
  setStaffNotesAction,
  createStaffNoteAction,
  updateStaffNoteAction,
  incrementRefreshKey,
  setStaffSortAction,
} = staffSlice.actions;

export default staffSlice.reducer;
